import { createContext } from 'react';

import { EMPTY_ID } from '@totem/components/common/reference/ReferenceSelector';
import {
  RemoteAccessDashboard,
  RemoteAccessOrganizationRiskSummaries,
} from '@totem/components/services/remoteAccess/v2/summary/types';

interface RemoteAccessDashboardContext {
  dashboardLoading: boolean;
  organizationSummaryLoading: boolean;
  dashboardData: RemoteAccessDashboard;
  organizationSummaryData: RemoteAccessOrganizationRiskSummaries;
  onBuildingChange: (buildingId: string) => void;
  selectedPropertyId: string;
}

export default createContext<RemoteAccessDashboardContext>({
  dashboardLoading: true,
  organizationSummaryLoading: true,
  dashboardData: null,
  organizationSummaryData: [],
  onBuildingChange: () => {},
  selectedPropertyId: EMPTY_ID,
});
